import { Route, Routes } from 'react-router-dom';
import PaginaPadrao from 'paginas/PaginaPadrao';
import Pagina404 from 'paginas/Pagina404';
import Inicio from 'paginas/Inicio';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PaginaPadrao />}>
        <Route index element={<Inicio />} />
      </Route>
      <Route path="*" element={<Pagina404 />} />
    </Routes>
  );
}
